import { useQuery } from '@tanstack/react-query';
import { api } from './api';

export type PlanKey = 'starter' | 'growth' | 'agency';

const DEFAULT_PLAN_PRICES: Record<PlanKey, string> = {
  starter: '49',
  growth: '149',
  agency: '399',
};

const formatPlanPrice = (value: string) => {
  const sanitized = value.replace(/[^0-9.]/g, '');
  const parsed = Number(sanitized);
  if (!Number.isFinite(parsed)) {
    return `$${value}`;
  }
  const formatted = parsed % 1 === 0 ? parsed.toFixed(0) : parsed.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
  return `$${formatted}`;
};

const getSettingValue = (
  settings: Array<{ key: string; value: string }>,
  key: string
) => settings.find(setting => setting.key === key)?.value;

export const usePlanPricing = () => {
  const { data: publicSettings = [] } = useQuery<Array<{ key: string; value: string }>>({
    queryKey: ['public-settings'],
    queryFn: async () => {
      try {
        const response = await api.serverAdmin.getPublicSettings();
        return response.data || [];
      } catch (error) {
        return [];
      }
    }
  });

  const planPrices: Record<PlanKey, string> = {
    starter: getSettingValue(publicSettings, 'plan_price_starter') || DEFAULT_PLAN_PRICES.starter,
    growth: getSettingValue(publicSettings, 'plan_price_growth') || DEFAULT_PLAN_PRICES.growth,
    agency: getSettingValue(publicSettings, 'plan_price_agency') || DEFAULT_PLAN_PRICES.agency,
  };

  const formattedPlanPrices: Record<PlanKey, string> = {
    starter: formatPlanPrice(planPrices.starter),
    growth: formatPlanPrice(planPrices.growth),
    agency: formatPlanPrice(planPrices.agency),
  };

  return {
    planPrices,
    formattedPlanPrices,
  };
};
